export default __webpack_public_path__ + "static/media/pic2.f47ab03b.jpg";